module.exports = __webpack_public_path__ + "static/media/bg.fe43c4ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/bg.jpg
// module id = 105
// module chunks = 0